<template>
  <div class="zhuzhuangtu_container" ref="chartRef"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "zhuzhuangtu_container",
  props: {
    wordcloudData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    cateWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      datax: [],
      datay: [],
      myChart: null,
      resizeObserver: null,
    };
  },
  watch: {
    wordcloudData(val) {
      if (val) {
        this.getOption();
      }
    },
  },
  mounted() {
    this.getOption();
    window.addEventListener("resize", this.handleResize);
    if (typeof ResizeObserver !== "undefined" && this.$refs.chartRef) {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.$refs.chartRef);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  },
  methods: {
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    getOption() {
      if (!this.$refs.chartRef) {
        return;
      }
      if (!this.myChart) {
        this.myChart = echarts.init(this.$refs.chartRef);
      }
      this.datax = [];
      this.datay = [];

      this.wordcloudData.forEach(element => {
        this.datax.push(element.name);
        this.datay.push(element.value);
      });

      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: "5%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.datax,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              interval: 0,
              rotate: 35,
              //多出字可以省略显示成点
              formatter: function (params) {
                var index = 15; //字数为6个超出就显示成点
                var newstr = "";
                for (var i = 0; i < params.length; i += index) {
                  var tmp = params.substring(i, i + index);
                  newstr += tmp + "";
                }
                if (newstr.length > 15) return newstr.substring(0, 15) + "...";
                else return "\n" + newstr;
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "论文数量",
            type: "bar",
            barWidth: "30px",
            data: this.datay,
          },
        ],
      };
      this.myChart.setOption(option, true);
      this.myChart.off("click");
      // 柱状图点击事件
      this.myChart.on("click", params => {
        if (params.componentType === "series" && params.seriesType === "bar") {
          // 这里可以处理点击事件，例如显示一个弹窗或执行其他操作

          this.$emit("wordcloud-event", params);
        }
      });
    },
  },
};
</script>

<style lang="scss" scope>
.zhuzhuangtu_container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
